import axios from '../../util/axios';
import '../../util/mock/zh/getParkInvestmentInfo';
import '../../util/mock/zh/getAdData';
import '../../util/mock/zh/getParkingData';
import '../../util/mock/zh/getOrganizationData';
import {
    runTableScrollAnim
} from '../../util/Animation';

import RentLayer from '../../layer/RentLayer';
import AdLayer from '../../layer/AdLayer';
import ParkingLayer from '../../layer/ParkingLayer';
import OrganizationLayer from '../../layer/OrganizationLayer';

/**
 * 园区招商
 */
export default class ParkInvestment {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.count = 0;
        this.leaseRegion = 'A区';
        this.htAnims = {};
        this.intervalAnims = {};
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        const dm = this.dm;

        // 左侧
        const overviewPanel = this.overviewPanel = dm.getDataByTag('parkInvestmentOverview');
        const regionLeasePanel = this.regionLeasePanel = dm.getDataByTag('parkInvestmentRegionLease');
        const regionLeaseAreaDetail = this.regionLeaseAreaDetail = dm.getDataByTag('regionLeaseAreaDetail');

        // 右侧
        const enterprisePanel = this.enterprisePanel = dm.getDataByTag('parkInvestmentEnterprise');
        const leasePanel = this.leasePanel = dm.getDataByTag('parkInvestmentLease');
        const parkOutputValuePanel = this.parkOutputValuePanel = dm.getDataByTag('parkOutputValue');
        const pricePanel = this.pricePanel = dm.getDataByTag('parkInvestmentPrice');

        axios.get('getParkInvestmentInfo').then(res => {
            this.subjectDatas = res;
            // 左一 总览
            const overviewInfo = res.overviewInfo;
            overviewPanel.getChildAt(1).a(overviewInfo);

            // 左二 园区租赁详情
            const regionLeaseData = res.regionLease[this.leaseRegion];
            if (regionLeaseData) {
                const _totalArea = regionLeaseData.useArea + regionLeaseData.rentArea;
                // regionLeasePanel.getChildAt(0).a('name', this.leaseRegion);
                regionLeasePanel.getChildAt(1).a('value', _totalArea);
                const names = ['useArea', 'rentArea', 'rentedArea', 'notRentedArea'];
                regionLeaseAreaDetail.eachChild((node, j) => {
                    const value = regionLeaseData[names[j]];
                    const percentValue = parseInt((value / (j === 0 || j === 1 ? _totalArea : regionLeaseData.rentArea)) * 100);
                    node.getChildAt(0).a('ht.serise', {
                        max: 100,
                        value: [percentValue + 10, percentValue],
                        gap: 4
                    })
                    node.getChildAt(1).a({
                        area: value,
                        percent: percentValue + '%'
                    });
                });
            }

            // 右一 入住企业
            const enterpriseData = res.enterprise;
            enterprisePanel.getChildAt(2).a('ht.dataSource', enterpriseData);

            // 右二 园区租赁
            const leaseAreaPanelData = res.leaseArea;
            const leaseAreaNames = res.leaseArea.name;
            const leasePanelNode = leasePanel.getChildAt(2);
            const leasePanelNodeSeries = leasePanelNode.a('ht.series');
            leasePanelNode.a({
                'seriesData1': leaseAreaPanelData.useArea,
                'seriesData2': leaseAreaPanelData.rentedArea,
                'seriesData3': leaseAreaPanelData.notRentedArea,
                'axisData': leaseAreaPanelData.time
            });
            console.log(leaseAreaNames);
            leasePanelNodeSeries[0].name = leaseAreaNames[0];
            leasePanelNodeSeries[1].name = leaseAreaNames[1];
            leasePanelNodeSeries[2].name = leaseAreaNames[2];

            // 右二 园区产值和税收
            const outputValuePanelData = res.outputValue;
            const outputValuePanelName = res.outputValue.name;
            const parkOutputValuePanelNode = parkOutputValuePanel.getChildAt(2);
            const parkOutputValuePanelNodeSeries = parkOutputValuePanelNode.a('ht.series');
            parkOutputValuePanelNode.a({
                'seriesData1': outputValuePanelData.taxRevenue,
                'seriesData2': outputValuePanelData.outputValue,
                'axisData': outputValuePanelData.time
            });
            parkOutputValuePanelNodeSeries[0].name = outputValuePanelName[0];
            parkOutputValuePanelNodeSeries[1].name = outputValuePanelName[1];

            // 右四 园区租赁价格
            const pricePanelData = res.prices;
            const pricePanelName = res.prices.name;
            const pricePanelNode = pricePanel.getChildAt(1);
            const pricePanelNodeSeries = pricePanelNode.a('ht.series');

            pricePanelNode.a('seriesData1', pricePanelData.region);
            pricePanelNode.a('xAxisData', pricePanelData.regionxAxis);
            pricePanelNodeSeries[0].name = pricePanelName[0];


            this.start2DAnim();
        });

    }

    /**
     * 启动 2D 上的动画
     */
    start2DAnim() {
        // 先清除动画,避免重复调用 start2DAnim 但未调用过 stop2DAnim 的误操作.
        this.stop2DAnim();

        const enterprisePanel = this.enterprisePanel;
        this.htAnims.tableRoll = runTableScrollAnim(enterprisePanel.getChildAt(2), {
            loop: true,
            dir: 1,
            delay: 0,
            duration: 2000
        });
    }

    /**
     * 停止移除 2D 上的动画
     */
    stop2DAnim() {
        Object.values(this.htAnims).forEach(anim => {
            anim.pause();
        });
        this.htAnims = {};
    }

    /**
     * 加载租赁图层
     */
    addRentLayer() {
        const map = this.main.pageMap.map;
        let rentLayer = this.rentLayer;

        map.flyTo({
            heading: 344.9556633164614,
            height: 399.1348937517482,
            pitch: -26.028916548843842,
            position: [118.04369706102459, 24.610155580400107],
            roll: 6.282451459589694,
            animation: {
                duration: 1000
            }
        }, () => {
            if (rentLayer) {
                rentLayer.showLayer();
            }
            else {
                axios.get('getBuildingData').then(res => {
                    res.reverse();
                    rentLayer = new RentLayer(map, res);
                    rentLayer.showLayer();
                    this.rentLayer = rentLayer;
                });
            }
        });
    }

    /**
     * 移除租赁图层
     */
    removeRentLayer() {
        let rentLayer = this.rentLayer;
        if (rentLayer) {
            rentLayer.hideLayer();
        }
    }

    /**
     * 新增广告位图层
     */
    addAdLayer() {
        const map = this.main.pageMap.map;
        let adLayer = this.adLayer;
        if (adLayer) {
            adLayer.showLayer();
        }
        else {
            axios.get('getAdData').then(res => {
                adLayer = new AdLayer(map, res);
                adLayer.showLayer();
                this.adLayer = adLayer;
            });
        }
    }
    /**
     * 移除广告位图层
     */
    removeAdLayer() {
        let adLayer = this.adLayer;
        if (adLayer) {
            adLayer.hideLayer();
        }
    }

    /**
     * 新增停车场图层
     */
    addParkingLayer() {
        const map = this.main.pageMap.map;
        let parkingLayer = this.parkingLayer;
        if (parkingLayer) {
            parkingLayer.showLayer();
        }
        else {
            axios.get('getParkingData').then(res => {
                res.reverse();
                parkingLayer = new ParkingLayer(map, res);
                parkingLayer.showLayer();
                this.parkingLayer = parkingLayer;
            });
        }
    }

    /**
     * 移除停车场图层
     */
    removeParkingLayer() {
        let parkingLayer = this.parkingLayer;
        if (parkingLayer) {
            parkingLayer.hideLayer();
        }
    }

    /**
     * 新增服务机构图层
     */
    addOrganizationLayer() {
        const map = this.main.pageMap.map;
        let organizationLayer = this.organizationLayer;
        if (organizationLayer) {
            organizationLayer.showLayer();
        }
        else {
            axios.get('getOrganizationData').then(res => {
                organizationLayer = new OrganizationLayer(map, res);
                organizationLayer.showLayer();
                this.organizationLayer = organizationLayer;
            });
        }
    }

    /**
     * 移除服务机构图层
     */
    removeOrganizationLayer() {
        let organizationLayer = this.organizationLayer;
        if (organizationLayer) {
            organizationLayer.hideLayer();
        }
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {
        this.removeRentLayer();
        this.removeAdLayer();
        this.removeParkingLayer();
        this.removeOrganizationLayer();

        this.stop2DAnim();
    }
}